import { useEffect, useState } from 'react';
import {
  readAutoHideRecordDiscussionPanel,
  RECORD_DISCUSSION_AUTO_HIDE_CHANGED_EVENT
} from './recordDiscussionPrefs';

const AUTO_HIDE_STORAGE_KEY = 'jarvis.patientTracking.recordDiscussion.autoHide';

export function useRecordDiscussionAutoHide(): boolean {
  const [autoHide, setAutoHide] = useState(() => readAutoHideRecordDiscussionPanel());

  useEffect(() => {
    const sync = () => setAutoHide(readAutoHideRecordDiscussionPanel());
    const onStorage = (event: StorageEvent) => {
      if (event.key !== AUTO_HIDE_STORAGE_KEY) return;
      sync();
    };
    window.addEventListener('storage', onStorage);
    window.addEventListener(RECORD_DISCUSSION_AUTO_HIDE_CHANGED_EVENT, sync);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener(RECORD_DISCUSSION_AUTO_HIDE_CHANGED_EVENT, sync);
    };
  }, []);

  return autoHide;
}
